import JumboScrollbar from '@jumbo/components/JumboScrollbar';
import { CircularProgress, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { getLocaleDateTime, getUserFullName } from 'app/utils/appHelpers';
import { dshCardScrollHeight, dshCardScrollHeightV2 } from 'config';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTemplateFontSettings } from 'styles/templateFontSettings';
import '../styles/customComponentCss.css';


function AgendaReviewListTable({ agendaReviews, setReviewInputStatus, otherScroll = false }) {

  const [loading, setLoading] = useState(false);
  const currentMeeting = useSelector((state) => state.meeting.currentMeeting);
  const [meetingUsers, setMeetingUsers] = useState([]);
  const { baseFontSize, smallFontSize } = useTemplateFontSettings();

  useEffect(() => {
    const getAPI = async () => {

      try {

        setLoading(true)
        let meetingUsers_ = currentMeeting.users.map(element => {
          if (element && element.id !== undefined) {
            const reviewObj = agendaReviews.find(item => item.userId === element.id);

            return {
              ...element,
              reviewObj: reviewObj,
            };
          } else {
            return element;
          }
        });

        setMeetingUsers(meetingUsers_)

      } catch (err) {
        // console.log('Hata:', err)
      } finally {
        if (setReviewInputStatus) {
          setReviewInputStatus(false)
        }

        setLoading(false);
      }

    };
    getAPI();

  }, [agendaReviews, setReviewInputStatus]);

  const styles = {
    position: 'relative',
    height: `${dshCardScrollHeight}`
  }

  return (
    <div style={otherScroll === 'none' ? {} : styles}>
      <Table style={{ margin: 0, padding: 0, lineHeight: 1 }} size="small" className="small-font-table">
        <TableHead>
          <TableRow>
            <TableCell
              style={{
                width: "30%",
                fontSize: baseFontSize,
                paddingBottom: 0,
                paddingTop: 0,
                paddingLeft: 5

              }}
            >
              Üye
            </TableCell>
            <TableCell
              style={{
                width: "70%",
                fontSize: baseFontSize,
                paddingBottom: 0,
                paddingTop: 0
              }}
            >
              Değerlendirme Metni
            </TableCell>
          </TableRow>
        </TableHead>
      </Table>

      {otherScroll === false ? (
        <JumboScrollbar
          autoHeight
          autoHeightMin={`${dshCardScrollHeightV2}`}

          autoHide
          autoHideDuration={200}
          autoHideTimeout={500}
        >
          <Table style={{ margin: 0, padding: 0, tableLayout: 'auto', lineHeight: 1 }} size='small'>
            <TableBody>
              {loading ? (
                <CircularProgress style={{ fontSize: baseFontSize }} />
              ) : (meetingUsers !== null && meetingUsers.length > 0) ? (
                meetingUsers.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        width: "30%",
                        fontSize: baseFontSize,
                        paddingBottom: 0,
                        paddingTop: 2,
                        paddingLeft: 5

                      }}
                    >


                      {item ? (
                        <>
                          {getUserFullName(item)}{" "}
                          <span style={{ fontStyle: "italic", fontSize: smallFontSize }}>
                            ({item.inst})
                          </span>
                        </>
                      ) : "Bilinmeyen Kullanıcı"}


                    </TableCell>
                    <TableCell
                      sx={{
                        wordWrap: "break-word",
                        whiteSpace: "normal",
                        minWidth: "100px",
                        maxWidth: "100px",
                        fontSize: baseFontSize,
                        width: "70%"
                      }}
                    >
                      {item
                        ? item.reviewObj !== undefined
                          ? item.reviewObj.info
                          : "Değerlendirme yapılmamış"
                        : ""}
                      <span
                        style={{
                          display: "block",
                          // marginTop: "5px",
                          fontStyle: "italic",
                          color: "#8595A6",
                          fontSize: baseFontSize
                        }}
                      >
                        {item
                          ? item.reviewObj !== undefined
                            ? getLocaleDateTime(item.reviewObj.pdate)
                            : ""
                          : ""}
                      </span>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={2} align="center" style={{ fontSize: baseFontSize }}>
                    Toplantıya henüz üye eklenmemiştir
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </JumboScrollbar>
      ) : (
        <Table style={{ margin: 0, padding: 0, tableLayout: 'auto', lineHeight: 1 }} size='small'>
          <TableBody>
            {loading ? (
              <CircularProgress style={{ fontSize: baseFontSize }} />
            ) : (meetingUsers !== null && meetingUsers.length > 0) ? (
              meetingUsers.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{
                      width: "30%",
                      fontSize: baseFontSize,
                      paddingBottom: 0,
                      paddingTop: 2,
                      paddingLeft: 5

                    }}
                  >
                    {item ? (
                      <>
                        {getUserFullName(item)}{" "}
                        <span style={{ fontStyle: "italic", fontSize: smallFontSize }}>
                          ({item.inst})
                        </span>
                      </>
                    ) : "Bilinmeyen Kullanıcı"}
                  </TableCell>
                  <TableCell
                    sx={{
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      minWidth: "100px",
                      maxWidth: "100px",
                      fontSize: baseFontSize,
                      width: "70%"
                    }}
                  >
                    {item
                      ? item.reviewObj !== undefined
                        ? item.reviewObj.info
                        : "Değerlendirme yapılmamış"
                      : ""}
                    <span
                      style={{
                        display: "block",
                        marginTop: "2px",
                        fontStyle: "italic",
                        color: "#8595A6",
                        fontSize: baseFontSize
                      }}
                    >
                      {item
                        ? item.reviewObj !== undefined
                          ? getLocaleDateTime(item.reviewObj.pdate)
                          : ""
                        : ""}
                    </span>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} align="center" style={{ fontSize: baseFontSize }}>
                  Toplantıya henüz üye eklenmemiştir
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </div>
  );
};

export default AgendaReviewListTable;